import api from "./api";

const syllabusService = {
  getSummary: (params) => api.get("/syllabus-progress/summary", { params }),

  getTeacherPerformance: (params) =>
    api.get("/syllabus-progress/teacher-performance", { params }),

  getSubjectProgress: (subjectId, params) =>
    api.get(`/syllabus-progress/subject/${subjectId}`, { params }),

  updateUnitProgress: (subjectId, unitNo, data) =>
    api.put(`/syllabus-progress/subject/${subjectId}/unit/${unitNo}`, data),

  bulkUpdateProgress: (subjectId, data) =>
    api.put(`/syllabus-progress/subject/${subjectId}/bulk`, data),

  getAll: (params) => api.get("/syllabus-progress", { params }),
};

export default syllabusService;
